import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-check_a91e019586d22b176d2089ec830d1437",
  "use": "ic-check_a91e019586d22b176d2089ec830d1437-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"ic-check_a91e019586d22b176d2089ec830d1437\">\n    <path d=\"M5.25 9.45L2.8 7l-.818.817 3.267 3.266 7-7-.817-.816L5.25 9.45z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id